module.exports = __webpack_public_path__ + "img/图1-27将圆五等分并画正五边形.e05400ec.png";